const controlHeightClasses = {
	xs: 'h-7',
	sm: 'h-8',
	default: 'h-9',
	lg: 'h-10',
} as const;

const controlSquareClasses = {
	xs: 'size-7',
	sm: 'size-8',
	default: 'size-9',
	lg: 'size-10',
} as const;

const controlIconClasses = {
	xs: "[&_svg:not([class*='size-'])]:size-3",
	sm: "[&_svg:not([class*='size-'])]:size-3",
	default: "[&_svg:not([class*='size-'])]:size-3.5",
	lg: "[&_svg:not([class*='size-'])]:size-3.5",
} as const;

type ControlSize = keyof typeof controlHeightClasses;

export { controlHeightClasses, controlIconClasses, controlSquareClasses };
export type { ControlSize };
